<script setup lang="ts">
import { StackLayout } from '@rfc/rfc-components-library'
import HomeAnnouncements from './Home/HomeAnnouncements.vue'
</script>

<template>
    <StackLayout direction="column" :gap="16" class="w-full h-full">
        <HomeAnnouncements />
    </StackLayout>
</template>
